/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from "react";
import Select from "react-select";
import { format, parse } from "date-fns";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { Controller, useForm } from "react-hook-form";

import StatsReports from "../statsReports";

import { StatisticsPropsType, StatisticsSearchProps } from "./types";



const CaseFilter: FC<StatisticsPropsType> = ({
    updateQueryParams,
    defaultQueryParams,
}): JSX.Element => {
    const { control, handleSubmit, getValues, reset, watch } = useForm<StatisticsSearchProps>({
        mode: "all",
        defaultValues: defaultQueryParams,
    });

    const start_date = watch("start_date");
    const end_date = watch("end_date");
    const [startOpen, setStartOpen] = useState(false);
    const [endOpen, setEndOpen] = useState(false);

    useEffect(() => {
        if (!defaultQueryParams) {
            return;
        }
        reset(defaultQueryParams);
    }, [defaultQueryParams, reset]);


    const closeDatePickers = () => {
        setStartOpen(false);
        setEndOpen(false);
    };
    const timeData = [
        { value: "day", label: "Daily" },
        { value: "week", label: "Weekly" },
        { value: "month", label: "Monthly" },
        { value: "quarter", label: "Quarterly" },
    ];
    // const periodData = [
    //   { value: 'period', label: 'vs Previous Period' },
    //   { value: 'year', label: 'vs Previous Year' },
    // ]
    const comparison = [
        { value: "p-1", label: "vs previous Period" },
        { value: "y-1", label: "vs Previous Year" },

    ]
    // ["ecrall", "parecrall", "ncrall", "all", "ncrparall"]
    const filterCaseData = [
        { value: "all", label: "All Cases" },
        { value: "ecr", label: "ECR Cases" },
        { value: "ncr", label: "Non-ECR Cases" },
        { value: "par", label: "PA Pending" },
        { value: "doc", label: "Missing Docs" },
    ];

    // const clearFormData = () => {
    //     const values = {
    //         start_date: format(
    //             new Date().setDate(new Date().getDate() - 30),
    //             "yyyy-MM-dd"
    //         ),
    //         end_date: format(
    //             new Date().setDate(new Date().getDate()),
    //             "yyyy-MM-dd"
    //         ),
    //         period: "day",
    //         filter: "",
    //         filter_type: "",
    //         type: "index",
    //     };

    //     reset(values);
    //     updateQueryParams(getValues(), true);
    // };

    const searchForStats = (values: StatisticsSearchProps) => {
        const updatedValues = {
            ...values,
            period: values.period
                ? typeof values.period === "string"
                    ? values.period
                    : (values.period as unknown as { value: string; label: string }).value
                : "",
            filter_type:
                values.filter_type ?
                    (typeof values.filter_type === "string" ? values.filter_type : (values.filter_type as unknown as { value: string; label: string; }).value)
                    : "",
            filter: values.filter
                ? typeof values.filter === "string"
                    ? values.filter
                    : (values.filter as unknown as { value: string; label: string }).value
                : "",
        };

        updateQueryParams(updatedValues, false);
    };

    return (
        <form onSubmit={handleSubmit(searchForStats)}>
            <div className="card mt-4">
                <div className="card-header bg-success-subtle">
                    <h4 className="m-0 text-black">Statistics</h4>
                </div>
                <div className="card-body px-3 pt-3">
                    <div className="row g-2 statistics-filter">
                        <div className="col date-col position-relative">
                            <Controller
                                name="start_date"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <>
                                    <DatePicker
                                        selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                                        onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                                        customInput={
                                            <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                                                <input {...inputProps} />}
                                            </ReactInputMask>
                                        }
                                        className="form-control rounded-1" wrapperClassName="w-100"
                                        placeholderText="mm/dd/yyyy"
                                        dateFormat="MM/dd/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        maxDate={end_date ? new Date(end_date) : undefined}
                                        open={startOpen}
                                        onFocus={() => {
                                            setStartOpen(true);
                                            setEndOpen(false);
                                        }}
                                        onClickOutside={() => setStartOpen(false)}
                                        onSelect={() => setStartOpen(false)}
                                    />
                                        <i
                                            className="bi bi-calendar position-absolute"
                                            style={{
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                            }}
                                        ></i>
                                        </>
                                )}
                            />
                        </div>
                        <div className="col date-col position-relative">
                            <Controller
                                name="end_date"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <>
                                    <DatePicker
                                        selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                                        onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                                        customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                                            <input {...inputProps} />}</ReactInputMask>}
                                        className="form-control rounded-1" wrapperClassName="w-100"
                                        placeholderText="mm/dd/yyyy"
                                        dateFormat="MM/dd/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        minDate={start_date ? new Date(start_date) : undefined}
                                        open={endOpen}
                                        onFocus={() => {
                                            setEndOpen(true);
                                            setStartOpen(false);
                                        }}
                                        onClickOutside={() => setEndOpen(false)}
                                        onSelect={() => setEndOpen(false)}
                                    />
                                    <i
                                            className="bi bi-calendar position-absolute"
                                            style={{
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                            }}
                                        ></i>
                                        </>
                                )}
                            />
                        </div>
                        <div className="col filters-col">
                            {/*<Controller
                                name="period"
                                control={control}
                                defaultValue={timeData[0].value}
                                render={({ field }) => (
                                    <Select
                                        isClearable={true}
                                        options={
                                            (timeData && timeData.length > 0
                                                ? timeData.map((item) => ({
                                                    value: item.value,
                                                    label: item.label,
                                                }))
                                                : []) as unknown as OptionsOrGroups<
                                                string,
                                                GroupBase<string>
                                            >
                                        }
                                        id="period"
                                        {...field}
                                        onFocus={closeDatePickers}
                                    />
                                )}
                            />*/}
                            {/* <Controller
                                        name="period"
                                        control={control}
                                        defaultValue={timeData?.[0].value || ""} // full object, not just .value
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                id="period"
                                                isClearable
                                                options={
                                                    timeData?.map((item) => ({
                                                        value: item.value,
                                                        label: item.label,
                                                    })) || []
                                                }
                                                value={
                                                    timeData?.find((option) => option.value === field.value) || null
                                                }
                                                onChange={(selectedOption) => field.onChange(selectedOption)}

                                                onFocus={closeDatePickers}
                                            />
                                        )}
                                    /> */}
                            <Controller
                                name="period"
                                control={control}
                                defaultValue={timeData?.[0]?.value || ""} // store only the value
                                render={({ field }) => (
                                    <Select
                                        id="period"
                                        isClearable
                                        options={
                                            timeData?.map((item) => ({
                                                value: item.value,
                                                label: item.label,
                                            })) || []
                                        }
                                        // ✅ react-select expects an option object, not a primitive value
                                        value={
                                            timeData?.find((option) => option.value === field.value) || null
                                        }
                                        onChange={(selectedOption) => field.onChange(selectedOption?.value || "")}
                                        onFocus={closeDatePickers}
                                    />
                                )}
                            /></div>
                        <div className="col filters-col">
                            <Controller
                                name="filter_type"
                                control={control}
                                defaultValue={comparison[0].value}
                                render={({ field }) => (
                                    <Select
                                        isClearable={true}
                                        placeholder={"Compare With ..."}
                                        options={
                                            comparison.map((item) => ({
                                                value: item.value,
                                                label: item.label,
                                            })) || []
                                        }
                                        id="filter_type"
                                        {...field}
                                        value={
                                            comparison?.find((option) => option.value === field.value) || null
                                        }
                                        onChange={(selectedOption) => field.onChange(selectedOption?.value || "")}
                                        onFocus={closeDatePickers}
                                    />
                                )}
                            />
                        </div>
                        <div className="col filters-col">
                            <Controller
                                name="filter"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        isClearable={true}
                                        options={
                                            filterCaseData.map((item) => ({
                                                value: item.value,
                                                label: item.label,
                                            })) || []
                                        }
                                        id="filter"
                                        {...field}
                                        value={
                                            filterCaseData?.find((option) => option.value === field.value) || null
                                        }
                                        onChange={(selectedOption) => field.onChange(selectedOption?.value || "")}
                                        placeholder={"Filter ..."}
                                        onFocus={closeDatePickers}
                                    />
                                )}
                            />
                        </div>
                        <div className="col filter-buttons d-flex gap-2">
                            <button type="submit" className="btn btn-blue text-nowrap">
                                <i className="fas fa-sync-alt"></i> Refresh
                            </button>
                            {/* <button type="button" className="btn btn-light text-nowrap"
                                onClick={() => clearFormData()}>
                                Clear
                            </button> */}
                        </div>
                    </div>
                    <StatsReports getValues={getValues} />
                </div>
            </div>
        </form>
    );
};

export default CaseFilter;
